/**
 * track.js
 *
 * Description
 *   Shared JS routines used by Track.  These are only for the master branch.
 *   Any code that could be reused by the web_rewrite branch should be put in
 *   the web_bs/js/scs_track_shared.js
 */

/**
 * Callback function for rendering the preflight status column.  This is used
 * when viewing a submission or when viewing the individual files.
 */
function renderPreflightStatusColumn( td, table, col, row ) {
  var userData = table.getUserData(),
      icon = getPreflightStatusIcon( parseInt( row["PREFLIGHTSTATUS"], 10 ),
                                     row["FILEID"],
                                     function() {
                                       loadFilesTable( userData["confirmationNumber"] );
                                     } );

  if ( !isUndefinedOrNull( row["NUMFILES"] ) ) {
    /* For a submission. */
    var info = getPreflightInfoHtml( row["PREFLIGHTSTATUS"],
                                     row["NUMFILES"],
                                     row["PREFLIGHTNONEFILES"],
                                     row["PREFLIGHTPENDINGFILES"],
                                     row["PREFLIGHTERRORFILES"],
                                     row["PREFLIGHTOKFILES"],
                                     row["PREFLIGHTCANCELEDFILES"] );
    overlibConnect( td, info );
  }

  replaceChildNodes( td, icon );
  return td;
}

function hideIfGrid( td, table, col, row ) {
  if ( sT_searcharttable.tGridView ) {
    td.innerHTML = "";
  }
  return td;
}

function shortenDirName( td, table, col, row ) {
  if ( !sT_searcharttable.tGridView ) {
    var dir = td.firstChild.innerHTML;
    if ( dir.length > 25 ) {
      dir = dir.substr( 0, 10 ) + "..." + dir.substr( -10 );
    }
    td.firstChild.innerHTML = dir;
  } else {
    td.innerHTML = "";
  }
  return td;
}

function shortenFileName( td, table, col, row ) {
  if ( !sT_searcharttable.tGridView ) {
    var fileName = td.firstChild.innerHTML;
    var ext = "";
    if ( fileName.length - fileName.lastIndexOf( "." ) <= 5 ) {
      ext = fileName.substr( fileName.lastIndexOf( "." ) );
      fileName = fileName.substr( 0, fileName.lastIndexOf( "." ) );
    }
    if ( fileName.length > 25 ) {
      fileName = fileName.substr( 0, 20 ) + ".." + ext;
    } else {
      fileName += ext;
    }
    td.firstChild.innerHTML = fileName;
  } else {
    td.innerHTML = "";
  }
  return td;
}

function renderThumbnail( td, table, col, row ) {
  var params = {
    "ThumbnailPath": row[ "THUMBNAIL" ],
    "timestamp": new Date().getTime()
  };
  var url = constructURL( "getartthumbnail", params, menuManager.getLocCGI_AI(), row[ "FILENAME" ] + ".png" );
  appendChildNodes( td, IMG( { "src": url, "alt": row[ "FILENAME" ] + " preview", "style": "width: 100px" } ) );
  return td;
}

function renderAdThumbnail( td, table, col, row ) {
  var params = {
    "adid": row[ "ADID" ],
    "timestamp": new Date().getTime()
  };
  var url = constructURL( "getthnail", params, menuManager.getLocCGI_AI(),
                          row[ "ORDERID" ] + ".gif" );
  appendChildNodes( td, IMG( { "src": url, "alt": row[ "ORDERID" ] + " preview" } ) );
  return td;
}

var gUploadFilesDiv = null;

/**
 * Load the upload files table for the given confirmation number.
 */
function viewConfirmationFiles( confirmationNumber ) {
  var rootElem = $( "files_floating_div" );
  if ( !gUploadFilesDiv ) {
    gUploadFilesDiv = new FloatingDiv( rootElem,
                                         { "title": "Files",
                                           "cancelStandard": true,
                                           "cancelText": "Close",
                                           "disposeOnHide": false } );
  }
  loadFilesTable( confirmationNumber );
  showElement( rootElem );
  gUploadFilesDiv.show();
}

function viewConfirmation( confirmNum ) {
  openURL( "adsubmit", [ "confirm_num" ], [ confirmNum ],
           menuManager.getLocCGI_AI() );
}

function loadFilesTable( confirmationNumber ) {
  // Load the table of uploaded files.
  var params = { "command": "uploadfilesload",
                 "confirmnum": confirmationNumber };
  var url = "spice.pl?" + queryString( params );
  sT_uplfiles.loadFromURL( url );
  sT_uplfiles.setUserData( { "confirmationNumber": confirmationNumber } );
  this.confirmNumber = confirmationNumber;
}
